import { SkeletonLoader, Typo } from "@pepperstone/pepper-ui-kit";

import { StaticHeadlineMetricData } from "./types";

export const OverviewInfoDashboardSkeleton = ({
  staticHeadlineMetricData,
  isMobile = false,
}: {
  staticHeadlineMetricData: StaticHeadlineMetricData[];
  isMobile?: boolean;
}) => {
  return (
    <div
      className={`flex justify-between ${isMobile ? "flex-wrap justify-around gap-4" : ""}`}
      data-testid="overview-info-dashboard-skeleton"
    >
      {staticHeadlineMetricData.map((metric, index) => (
        <div
          key={index}
          className={`${isMobile && index === staticHeadlineMetricData.length - 1 ? "mx-auto" : ""}`}
        >
          <div className="rounded-xl bg-white py-6">
            <div className="flex items-center gap-2">
              <div className="rounded-full bg-gray-100 p-0.5">
                <SkeletonLoader variant="circular" width={5} height={5} />
              </div>
              <Typo
                elem="h2"
                type="label"
                size="md"
                textColor="ps-text-text-primary-secondary"
              >
                {metric.title}
              </Typo>
            </div>
            <div className="mb-2 mt-4">
              <SkeletonLoader variant="rectangular" height={10} width={24} />
            </div>
            <div className="mt-1">
              <SkeletonLoader variant="rectangular" height={8} width={40} />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};
